import EatingTimerBody from './EatingTimerBody';

export default EatingTimerBody;
